// Module
var code = "<react-component name=\"RecentActivity\" props=\"{eventId: event.id, eventBookingCount: event.bookings_count}\"></react-component>\n";
// Exports
module.exports = code;